import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import LocationLayer from "../../components/message/LocationLayer";

const LocationPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Location Page" />


        {/* SingleLayer */}
        <LocationLayer />

      </MasterLayout>
    </>
  );
};

export default LocationPage;
